var React = require('react');

function EscalatorUpInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M14.087 42H9a6 6 0 1 0 0 12h6.432a12 12 0 0 0 9.163-4.252l22.263-26.33A4 4 0 0 1 49.913 22H55a6 6 0 1 0 0-12h-6.432a12 12 0 0 0-9.163 4.252l-22.263 26.33A4 4 0 0 1 14.087 42z","strokeLinecap":"square","key":0}),React.createElement("circle",{"strokeLinecap":"square","cx":"22","cy":"18","r":"3","key":1}),React.createElement("path",{"d":"M19 38.5V25a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6m26 12L41 53","key":2}),React.createElement("path",{"strokeLinecap":"square","d":"M43 43h8v8","key":3})]));
}

EscalatorUpInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = EscalatorUpInline;

EscalatorUpInline.default = EscalatorUpInline;
